// extracted by mini-css-extract-plugin
export var button = "_a1-7";
export var buttonRow = "_a1-6";
export var fadeIn = "_a1-1";
export var gradient = "_a1-0";
export var panel = "_a1-2";
export var panelIn = "_a1-3";
export var subtitle = "_a1-5";
export var title = "_a1-4";